import { HttpClient } from "@angular/common/http";
import { identifierModuleUrl } from "@angular/compiler";
import { Injectable, Injector } from "@angular/core";
import { Router } from "@angular/router";
import { map, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class SessionService {

    connectorURL = null;

    session: { hsId: string, sessionId: string, allowShipping: boolean, allowPickup: boolean, state: SessionState };
    // hsId: string
    // sessionId: string
    // state

    croppedImage: any = null;
    noImage = false;
    shipping = 0;

    constructor(
        protected http: HttpClient,
        private injector: Injector,
        private router: Router,
        ) {
    }

    async loadConnectorEndpoint(): Promise<void> {
        const jsonFile = 'assets/config.dev.json';
        console.log('load config:', jsonFile);
        const http = this.injector.get(HttpClient);
        const settings = await http.get(jsonFile).toPromise()

        console.log('loaded config:', settings);
        this.connectorURL = settings['endpoints']['c4y-connector'];
        console.log('connectorURL:', this.connectorURL);
    }

    async completeSession(): Promise<boolean> {
        console.log(this);
        try {
            await this.http.post(`${this.connectorURL}/c4y/session/${this.session.sessionId}/`,
                {
                    image: this.trimImageString(this.croppedImage),
                    desiredShipping: this.shipping
                }).toPromise();
            return true;
        } catch (e) {
            console.warn(e);
            return false;
        } finally {
        }

    }


    cancelSession(): void {
        this.completeSessionWithState(1);
    }

    async completeSessionWithState(newState: number): Promise<void> {
        await this.http.post(`${this.connectorURL}/c4y/session/${this.session.sessionId}/complete/`, { newState }).toPromise().catch();
    }


    async loadSession(sessionId?: string): Promise<any> {
        this.session = await this.http.get<any>(`${this.connectorURL}/c4y/session/${sessionId ?? this.session.sessionId}/`).toPromise();

        if(this.session?.allowShipping){
            this.shipping = 1;
        }else if(this.session?.allowPickup){
            this.shipping = 0;
        }
    }


    public trimImageString(imageString: string): string {
        if (!imageString) return undefined;

        return imageString.replace('data:image/png;base64,', '')
            .replace('data:image/gif;base64,', '')
            .replace('data:image/jpg;base64,', '')
            .replace('data:image/jpeg;base64,', '');
    }

    public async imageFaceDetectionOnServer(): Promise<boolean> {
        const imageBase64 = this.trimImageString(this.croppedImage);
        return await this.http.post<any>(`${this.connectorURL}/c4y/session/${this.session.sessionId}/detectface`, { data: imageBase64 })
          .pipe(map(res => res.result)).toPromise().catch(() => false);
      }
}

export enum SessionState {
    Active,
    Cancelled,
    Photo,
    NoPhoto,
    Error
}
